
<div
[style.background-color]="
  (isChecked && type === 'square' && !disabled) ? backGroundTrue : 
  (disabled ? backGroundDisabled : backGroundFalse)"
[style.border-color]="
  (isChecked && !disabled) ? borderTrue : 
  (disabled ? borderDisabled : borderFalse)"
[style.opacity]="!isChecked && !disabled ? '0.5' : '1'"
[style.width]="width"
[style.height]="height"
[style.border-radius]="borderRadius"
(click)="onChangeCheck($event)"
[class]="disabled ? 'cursor-not-allowed' : 'cursor-pointer'"
class="flex items-center justify-center border-[3px]
       focus:ring-2 focus:ring-[#A2D5CE] shadow"
[ngClass]="{
  'w-[26px] h-[26px]': size === 'sm',
  'w-[30px] h-[30px]': size === 'md',
  'w-[45px] h-[45px] rounded-xl': size === 'lg',
  'rounded-lg': size === 'sm' || size === 'md',
  '!rounded-full ': type === 'circle',
}"
>
    <svg [ngClass]="{
           'w-5 h-5': (size === 'sm' || size === 'md'),
           'w-[27px] h-[27px]': size === 'lg'
         }"
      class="text-white" 
      *ngIf="isChecked && type === 'square'" 
      viewBox="0 0 20 20" 
      fill="currentColor"
    >
      <path 
        fill-rule="evenodd" 
        d="M16.707 5.293a1 1 0 00-1.414-1.414L7 12.172 4.707 9.879a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l9-9z" 
        clip-rule="evenodd" 
      />
    </svg>
    <div *ngIf="type==='circle'" class=" flex items-center justify-center "
    [style.background-color]="
  (isChecked  && !disabled) ? backGroundTrue : 
  (disabled ? backGroundDisabled : backGroundFalse)"
    [ngClass]="{
      'w-[16px] h-[16px]': size === 'sm',
      'w-[20px] h-[20px]': size === 'md',
      'w-[35px] h-[35px] rounded-xl': size === 'lg',
      'rounded-lg': size === 'sm' || size === 'md',
      '!rounded-full ': type === 'circle',
    }">

    </div>
  </div>

